import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { 
  Lightbulb, 
  Bell, 
  Users, 
  Coins, 
  ShieldCheck, 
  Truck, 
  Award, 
  Heart,
  ArrowRight,
  ChevronRight,
  Mail,
  Facebook,
  Instagram,
  Phone,
  MapPin,
  Wine,
  Menu,
  X
} from "lucide-react";
import { Button } from "@/components/ui/button";

const BenefitsPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToRegister = () => {
    window.location.href = "/#register-form";
  };

  const mainBenefits = [
    {
      icon: Lightbulb,
      title: "Novidades Exclusivas",
      description: "Seja o primeiro a descobrir novos vinhos artesanais e produtores que entram na plataforma. Receba recomendações personalizadas baseadas no seu perfil e preferências.",
      features: ["Alertas de novos produtores", "Recomendações personalizadas", "Acesso antecipado a lançamentos"]
    },
    {
      icon: Bell,
      title: "Seja Avisado da Abertura",
      description: "Registre-se agora e seja notificado assim que a plataforma estiver disponível. Ganhe vantagens exclusivas por ser um dos primeiros membros.",
      features: ["Notificação prioritária", "Descontos de lançamento", "Acesso VIP à plataforma"]
    },
    {
      icon: Users,
      title: "Conheça Produtores Locais",
      description: "Conecte-se diretamente com produtores artesanais de todas as regiões de Portugal. Conheça as histórias por trás de cada garrafa.",
      features: ["Perfis detalhados dos produtores", "Histórias e tradições", "Comunicação direta"]
    },
    {
      icon: Coins,
      title: "Ganhe Comissão por Indicações",
      description: "Indique amigos e ganhe comissões em cada compra realizada. Quanto mais pessoas você trouxer, mais você ganha.",
      features: ["Programa de afiliados", "Comissões recorrentes", "Bónus por metas"]
    }
  ];

  const additionalBenefits = [
    {
      icon: ShieldCheck,
      title: "Garantia de Qualidade",
      description: "Todos os produtores são verificados e seus vinhos passam por rigoroso controle de qualidade."
    },
    {
      icon: Truck,
      title: "Entrega Segura",
      description: "Embalagens especiais para garantir que seu vinho chegue em perfeitas condições."
    },
    {
      icon: Award,
      title: "Vinhos Premiados",
      description: "Acesso a vinhos artesanais premiados em concursos nacionais e internacionais."
    },
    {
      icon: Heart,
      title: "Apoie o Local",
      description: "Comprando direto do produtor, você apoia a economia local e tradições centenárias."
    }
  ];

  const forProducers = [
    {
      title: "Alcance Novos Clientes",
      description: "Expanda seu mercado e alcance consumidores apaixonados por vinhos artesanais em todo o país."
    },
    {
      title: "Gestão Simplificada",
      description: "Painel administrativo completo para gerir pedidos, estoque e comunicação com clientes."
    },
    {
      title: "Marketing Incluído",
      description: "Sua marca divulgada na plataforma com fotos profissionais e descrições otimizadas."
    },
    {
      title: "Pagamentos Seguros",
      description: "Receba pagamentos de forma segura e rápida, com relatórios financeiros detalhados."
    }
  ];

  return (
    <div className="min-h-screen" style={{ fontFamily: "'Lato', sans-serif" }}>
      {/* Header/Navbar */}
      <header 
        className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.98)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_wine-marketplace-7/artifacts/q5fe9prt_logo1_ocaseirinho.png"
                alt="O Caseirinho"
                className="h-16 w-auto"
              />
            </Link>
            
            <nav className="hidden md:flex items-center gap-8">
              <Link 
                to="/"
                className="text-[#722F37] hover:text-[#5a232b] transition-colors text-sm font-medium"
              >
                Início
              </Link>
              <Link 
                to="/produtores"
                className="text-[#722F37] hover:text-[#5a232b] transition-colors text-sm font-medium"
              >
                Produtores
              </Link>
              <Link 
                to="/beneficios"
                className="text-[#722F37] hover:text-[#5a232b] transition-colors text-sm font-medium border-b-2 border-[#722F37]"
              >
                Benefícios
              </Link>
              <button 
                onClick={scrollToRegister}
                className="px-5 py-2 rounded text-sm font-medium transition-colors"
                style={{
                  backgroundColor: '#722F37',
                  color: '#FFFFFF'
                }}
              >
                Cadastre-se
              </button>
            </nav>
            
            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-[#722F37] p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
          
          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              <nav className="flex flex-col gap-3">
                <Link 
                  to="/"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-[#722F37] hover:text-[#5a232b] transition-colors text-left py-2"
                >
                  Início
                </Link>
                <Link 
                  to="/produtores"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-[#722F37] hover:text-[#5a232b] transition-colors text-left py-2"
                >
                  Produtores
                </Link>
                <Link 
                  to="/beneficios"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-[#722F37] hover:text-[#5a232b] transition-colors text-left py-2 font-semibold"
                >
                  Benefícios
                </Link>
                <button 
                  onClick={() => { scrollToRegister(); setMobileMenuOpen(false); }}
                  className="px-5 py-2 rounded text-sm font-medium transition-colors text-center mt-2"
                  style={{
                    backgroundColor: '#722F37',
                    color: '#FFFFFF'
                  }}
                >
                  Cadastre-se
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section 
        className="relative pt-32 pb-20 overflow-hidden"
        style={{
          backgroundColor: '#722F37'
        }}
      >
        <div className="max-w-6xl mx-auto px-4 text-center relative z-10">
          <span 
            className="inline-block px-4 py-2 rounded-full text-sm font-medium mb-6"
            style={{ backgroundColor: 'rgba(212, 175, 55, 0.2)', color: '#D4AF37' }}
          >
            Descubra as Vantagens
          </span>
          
          <h1 
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
            style={{ 
              fontFamily: "'Playfair Display', serif",
              color: '#F5EDE0'
            }}
          >
            Benefícios de Fazer Parte
            <br />
            <span style={{ color: '#D4AF37' }}>do Caseirinho</span>
          </h1>
          
          <p 
            className="text-lg md:text-xl max-w-3xl mx-auto mb-10"
            style={{ color: 'rgba(245, 237, 224, 0.9)' }}
          >
            Seja você um apreciador de vinhos ou um produtor artesanal, 
            descubra todas as vantagens de se juntar à nossa comunidade.
          </p>
          
          <button 
            onClick={scrollToRegister}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:shadow-xl hover:scale-105"
            style={{
              backgroundColor: '#D4AF37',
              color: '#722F37'
            }}
          >
            Quero me Cadastrar
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </section>

      {/* Main Benefits Section */}
      <section className="py-20" style={{ backgroundColor: '#F5EEE0' }}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 
              className="text-3xl md:text-4xl font-bold mb-4"
              style={{ 
                fontFamily: "'Playfair Display', serif",
                color: '#722F37'
              }}
            >
              Para Quem Quer Comprar
            </h2>
            <div 
              className="w-24 h-1 mx-auto"
              style={{ backgroundColor: '#D4AF37' }}
            ></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {mainBenefits.map((benefit, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
                style={{ border: '1px solid rgba(114, 47, 55, 0.1)' }}
              >
                <div 
                  className="w-16 h-16 rounded-xl flex items-center justify-center mb-6"
                  style={{ backgroundColor: 'rgba(212, 175, 55, 0.15)' }}
                >
                  <benefit.icon className="w-8 h-8" style={{ color: '#D4AF37' }} />
                </div>
                
                <h3 
                  className="text-xl font-bold mb-3"
                  style={{ 
                    fontFamily: "'Playfair Display', serif",
                    color: '#722F37'
                  }}
                >
                  {benefit.title}
                </h3>
                
                <p 
                  className="mb-5 leading-relaxed"
                  style={{ color: '#5D4037' }}
                >
                  {benefit.description}
                </p>
                
                <ul className="space-y-2">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm" style={{ color: '#5D4037' }}>
                      <ChevronRight className="w-4 h-4" style={{ color: '#D4AF37' }} />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Benefits */}
      <section 
        className="py-20"
        style={{
          backgroundColor: '#722F37'
        }}
      >
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 
              className="text-3xl md:text-4xl font-bold mb-4"
              style={{ 
                fontFamily: "'Playfair Display', serif",
                color: '#F5EDE0'
              }}
            >
              E Muito Mais...
            </h2>
            <div 
              className="w-24 h-1 mx-auto"
              style={{ backgroundColor: '#D4AF37' }}
            ></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {additionalBenefits.map((benefit, index) => (
              <div 
                key={index}
                className="text-center p-6 rounded-xl transition-all duration-300 hover:transform hover:scale-105"
                style={{ 
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(212, 175, 55, 0.2)'
                }}
              >
                <div 
                  className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
                  style={{ backgroundColor: 'rgba(212, 175, 55, 0.2)' }}
                >
                  <benefit.icon className="w-7 h-7" style={{ color: '#D4AF37' }} />
                </div>
                
                <h3 
                  className="text-lg font-bold mb-2"
                  style={{ 
                    fontFamily: "'Playfair Display', serif",
                    color: '#F5EDE0'
                  }}
                >
                  {benefit.title}
                </h3>
                
                <p 
                  className="text-sm"
                  style={{ color: 'rgba(245, 237, 224, 0.8)' }}
                >
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* For Producers Section */}
      <section className="py-20" style={{ backgroundColor: '#F5EEE0' }}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <span 
                className="inline-block px-4 py-2 rounded-full text-sm font-medium mb-4"
                style={{ backgroundColor: 'rgba(114, 47, 55, 0.1)', color: '#722F37' }}
              >
                Para Produtores
              </span>
              
              <h2 
                className="text-3xl md:text-4xl font-bold mb-6"
                style={{ 
                  fontFamily: "'Playfair Display', serif",
                  color: '#722F37'
                }}
              >
                Expanda Seu Negócio
                <br />
                <span style={{ color: '#D4AF37' }}>com o Caseirinho</span>
              </h2>
              
              <p 
                className="text-lg mb-8 leading-relaxed"
                style={{ color: '#5D4037' }}
              >
                Se você é um produtor de vinhos artesanais, o Caseirinho é a plataforma 
                perfeita para alcançar novos clientes e expandir seu negócio. 
                Junte-se a nós e faça parte de uma comunidade que valoriza a tradição 
                e a qualidade.
              </p>

              <div className="space-y-4">
                {forProducers.map((item, index) => (
                  <div 
                    key={index}
                    className="flex gap-4 p-4 rounded-lg bg-white"
                    style={{ border: '1px solid rgba(114, 47, 55, 0.1)' }}
                  >
                    <div 
                      className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: 'rgba(212, 175, 55, 0.15)' }}
                    >
                      <span style={{ color: '#D4AF37', fontWeight: 'bold' }}>{index + 1}</span>
                    </div>
                    <div>
                      <h4 
                        className="font-bold mb-1"
                        style={{ color: '#722F37' }}
                      >
                        {item.title}
                      </h4>
                      <p className="text-sm" style={{ color: '#5D4037' }}>
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <div 
                className="rounded-2xl overflow-hidden shadow-2xl"
                style={{ border: '4px solid #D4AF37' }}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_728153dc-96ca-4c27-a962-b3dd550d3ec5/artifacts/kb4oajh6_vinhos.png"
                  alt="Vinhos O Caseirinho"
                  className="w-full h-auto"
                />
              </div>
              
              {/* Floating badge */}
              <div 
                className="absolute -bottom-6 -left-6 bg-white rounded-xl p-4 shadow-xl"
                style={{ border: '2px solid #D4AF37' }}
              >
                <div className="flex items-center gap-3">
                  <div 
                    className="w-12 h-12 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: '#722F37' }}
                  >
                    <Wine className="w-6 h-6" style={{ color: '#D4AF37' }} />
                  </div>
                  <div>
                    <p className="text-2xl font-bold" style={{ color: '#722F37' }}>100%</p>
                    <p className="text-xs" style={{ color: '#5D4037' }}>Artesanal</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section 
        className="py-20"
        style={{
          background: 'linear-gradient(135deg, #722F37 0%, #5D2E35 100%)'
        }}
      >
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 
            className="text-3xl md:text-4xl font-bold mb-6"
            style={{ 
              fontFamily: "'Playfair Display', serif",
              color: '#F5EDE0'
            }}
          >
            Pronto para Começar?
          </h2>
          
          <p 
            className="text-lg mb-10 max-w-2xl mx-auto"
            style={{ color: 'rgba(245, 237, 224, 0.9)' }}
          >
            Registre-se agora e seja um dos primeiros a fazer parte do Caseirinho. 
            Não perca a oportunidade de descobrir vinhos artesanais únicos ou 
            expandir o seu negócio.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button 
              onClick={scrollToRegister}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:shadow-xl"
              style={{
                backgroundColor: '#D4AF37',
                color: '#722F37'
              }}
            >
              Quero Comprar Vinhos
              <ArrowRight className="w-5 h-5" />
            </button>
            
            <button 
              onClick={scrollToRegister}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:shadow-xl"
              style={{
                backgroundColor: 'transparent',
                color: '#F5EDE0',
                border: '2px solid #D4AF37'
              }}
            >
              Sou Produtor
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer 
        className="pt-16 pb-8"
        style={{
          backgroundColor: '#722F37',
          borderTop: '4px solid #D4AF37'
        }}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            
            {/* Column 1 - About/Logo */}
            <div className="lg:col-span-1">
              <div className="mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_728153dc-96ca-4c27-a962-b3dd550d3ec5/artifacts/c8drzsa3_logo3_dark_badge-removebg-preview.png"
                  alt="O Caseirinho - Produtos Artesanais"
                  className="h-24 w-auto"
                />
              </div>
              <p 
                className="text-sm leading-relaxed mb-6"
                style={{ color: 'rgba(245, 237, 224, 0.8)' }}
              >
                Conectamos apaixonados por vinho a produtores artesanais de todo o país. Qualidade e tradição em cada garrafa.
              </p>
              <div className="flex items-center gap-3">
                <a 
                  href="https://facebook.com/caseirinho"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  style={{ backgroundColor: 'rgba(212, 175, 55, 0.2)', border: '1px solid rgba(212, 175, 55, 0.3)' }}
                >
                  <Facebook className="w-5 h-5" style={{ color: '#D4AF37' }} />
                </a>
                <a 
                  href="https://instagram.com/caseirinho"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  style={{ backgroundColor: 'rgba(212, 175, 55, 0.2)', border: '1px solid rgba(212, 175, 55, 0.3)' }}
                >
                  <Instagram className="w-5 h-5" style={{ color: '#D4AF37' }} />
                </a>
              </div>
            </div>

            {/* Column 2 - Quick Links */}
            <div>
              <h4 
                className="text-lg font-semibold mb-5"
                style={{ 
                  fontFamily: "'Playfair Display', serif",
                  color: '#F5EDE0'
                }}
              >
                Links Rápidos
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link 
                    to="/"
                    className="flex items-center gap-2 text-sm transition-colors duration-200 hover:text-[#D4AF37]"
                    style={{ color: 'rgba(245, 237, 224, 0.8)' }}
                  >
                    <ChevronRight className="w-4 h-4" style={{ color: '#D4AF37' }} />
                    Início
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/beneficios"
                    className="flex items-center gap-2 text-sm transition-colors duration-200 hover:text-[#D4AF37]"
                    style={{ color: 'rgba(245, 237, 224, 0.8)' }}
                  >
                    <ChevronRight className="w-4 h-4" style={{ color: '#D4AF37' }} />
                    Benefícios
                  </Link>
                </li>
                <li>
                  <a 
                    href="/#register-form"
                    className="flex items-center gap-2 text-sm transition-colors duration-200 hover:text-[#D4AF37]"
                    style={{ color: 'rgba(245, 237, 224, 0.8)' }}
                  >
                    <ChevronRight className="w-4 h-4" style={{ color: '#D4AF37' }} />
                    Registrar
                  </a>
                </li>
                <li>
                  <a 
                    href="#"
                    className="flex items-center gap-2 text-sm transition-colors duration-200 hover:text-[#D4AF37]"
                    style={{ color: 'rgba(245, 237, 224, 0.8)' }}
                  >
                    <ChevronRight className="w-4 h-4" style={{ color: '#D4AF37' }} />
                    Política de Privacidade
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3 - Contact */}
            <div>
              <h4 
                className="text-lg font-semibold mb-5"
                style={{ 
                  fontFamily: "'Playfair Display', serif",
                  color: '#F5EDE0'
                }}
              >
                Contacto
              </h4>
              <ul className="space-y-4">
                <li>
                  <a 
                    href="mailto:info@caseirinho.pt"
                    className="flex items-start gap-3 text-sm transition-colors duration-200 hover:text-[#D4AF37]"
                    style={{ color: 'rgba(245, 237, 224, 0.8)' }}
                  >
                    <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#D4AF37' }} />
                    <span>info@caseirinho.pt</span>
                  </a>
                </li>
                <li>
                  <a 
                    href="tel:+351912345678"
                    className="flex items-start gap-3 text-sm transition-colors duration-200 hover:text-[#D4AF37]"
                    style={{ color: 'rgba(245, 237, 224, 0.8)' }}
                  >
                    <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#D4AF37' }} />
                    <span>+351 912 345 678</span>
                  </a>
                </li>
                <li>
                  <div 
                    className="flex items-start gap-3 text-sm"
                    style={{ color: 'rgba(245, 237, 224, 0.8)' }}
                  >
                    <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#D4AF37' }} />
                    <span>Lisboa, Portugal</span>
                  </div>
                </li>
              </ul>
            </div>

            {/* Column 4 - CTA */}
            <div>
              <h4 
                className="text-lg font-semibold mb-5"
                style={{ 
                  fontFamily: "'Playfair Display', serif",
                  color: '#F5EDE0'
                }}
              >
                Mantenha-se Informado
              </h4>
              <p 
                className="text-sm mb-4"
                style={{ color: 'rgba(245, 237, 224, 0.8)' }}
              >
                Seja o primeiro a saber quando a plataforma estiver disponível.
              </p>
              <button 
                onClick={scrollToRegister}
                className="w-full py-3 px-4 rounded-lg text-sm font-semibold transition-all duration-300 hover:shadow-lg"
                style={{
                  backgroundColor: '#D4AF37',
                  color: '#722F37'
                }}
              >
                Registre-se Agora
              </button>
              
              <div className="flex items-center gap-2 mt-6">
                <Wine className="w-5 h-5" style={{ color: '#D4AF37' }} />
                <span 
                  className="text-xs"
                  style={{ color: 'rgba(245, 237, 224, 0.6)' }}
                >
                  100% Vinhos Artesanais
                </span>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div 
            className="w-full h-[1px] mb-8"
            style={{ backgroundColor: 'rgba(212, 175, 55, 0.3)' }}
          ></div>

          {/* Bottom Footer */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p 
              className="text-sm"
              style={{ color: 'rgba(245, 237, 224, 0.6)' }}
            >
              © {new Date().getFullYear()} O Caseirinho. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-6">
              <a 
                href="#"
                className="text-xs transition-colors duration-200 hover:text-[#D4AF37]"
                style={{ color: 'rgba(245, 237, 224, 0.6)' }}
              >
                Termos de Uso
              </a>
              <a 
                href="#"
                className="text-xs transition-colors duration-200 hover:text-[#D4AF37]"
                style={{ color: 'rgba(245, 237, 224, 0.6)' }}
              >
                Política de Privacidade
              </a>
              <a 
                href="#"
                className="text-xs transition-colors duration-200 hover:text-[#D4AF37]"
                style={{ color: 'rgba(245, 237, 224, 0.6)' }}
              >
                Cookies
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BenefitsPage;
